/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const WebSiteService = ({ color = 'forest', height = 14, width = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      sx={{ fill: color }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M9.1 12.6H12.6V9.1H9.1V12.6ZM7.7 14H14V7.7H7.7V14ZM9.1 4.9H12.6V1.4H9.1V4.9ZM7.7 6.3H14V0H7.7V6.3ZM1.4 12.6H4.9V1.4H1.4V12.6ZM0 14H6.3V0H0V14Z"
      />
    </svg>
  )
}

WebSiteService.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default WebSiteService
